import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Client } from 'src/app/core/entity/client';
import { getDateValidator } from 'src/app/core/entity/validation';
import { ValidationStatus } from 'src/app/core/entity/validationStatus';
import { toTitleMessage, toTextMessage } from 'src/app/core/entity/validationStrings';
import { getTranslationProvider } from 'src/app/core/i18n/getTranslationProvider';
import { TranslatableComponent } from 'src/app/core/i18n/TranslatableComponent';
import { ToastActions } from 'src/app/core/state/toast/toast.actions';
import { DirtyItem } from 'src/app/shared/misc/dirty.item';

@Component({
  selector: 'app-client-business-detail',
  templateUrl: './client.business.detail.component.html',
  providers: [getTranslationProvider('ClientBusinessDetailComponent')],
  styles: [
    `
      table > tr > td {
        padding: 2px;
      }
      table > tr > td.table-label {
        padding: 12px 2px 0 2px;
        font-weight: 600;
        font-size: 85%;
      }
    `,
  ],
})
export class ClientBusinessDetailComponent extends TranslatableComponent {
  @Output() detailsEmitter = new EventEmitter<Client>();
  @Output() dirtyEmitter = new EventEmitter<DirtyItem>();

  @Input()
  set client(client: Client) {
    this._clientBusinessDetails = client;
    this._originalClientBusinessDetails = { ...client };
  }

  get clientBusinessDetails() {
    return this._clientBusinessDetails;
  }

  minSelectableDate = new Date(1897, 0, 1);

  private _clientBusinessDetails: Client;
  private _originalClientBusinessDetails: Client;

  emitBusinessDetails() {
    this.detailsEmitter.emit(this.clientBusinessDetails);
    this.sendDirtyIfValueIsChanged();
  }

  close(saveFlag: number) {
    const { validate, min, max } = getDateValidator({ minDate: this.minSelectableDate });
    const { status, title, text } = validate(this.clientBusinessDetails.registrationDate, {
      min,
      max,
      label: this.translate('registrationDate'),
    });

    if (this.clientBusinessDetails.registrationDate && status !== ValidationStatus.Ok && saveFlag !== -1) {
      const scope = 'validation';
      const summary = toTitleMessage(this.translateWithOtherScope(scope, title.key), title);
      const detail = toTextMessage(this.translateWithOtherScope(scope, text?.key), text);

      this.store.dispatch(ToastActions.showWarnMessage({ summary, detail }));
      return;
    }

    this.clientBusinessDetails.saveFlag = saveFlag;
    this.detailsEmitter.emit(this.clientBusinessDetails);
  }

  private sendDirtyIfValueIsChanged() {
    const fieldsToCheck = [
      'businessArea',
      'registrationDate',
      'description',
      'specialRules',
      'otherInfo',
      'bank',
      'accountant',
    ];
    const isAnyFieldChanged = fieldsToCheck.some((key) => {
      return this.clientBusinessDetails[key] !== this._originalClientBusinessDetails[key];
    });

    if (isAnyFieldChanged) {
      this.dirtyEmitter.emit(new DirtyItem('BusinessDetails', true));
      return;
    }
  }
}
